'use client'
import { Avatar, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger, Tooltip } from '@nextui-org/react'
import Link from 'next/link'
import React, { useContext } from 'react'
import { EditorRoute, Route } from '@/routers/routes'
import { translateIt } from '@/data/translations'
import { UserContext } from '@/library/entities/core/user/contexts/UserContext'
import { toast } from 'sonner'


export default function MeAvatar(props) {
  const { me, countryId, size = "md" } = props
  const { logout } = useContext(UserContext)
  const defaultAvatar = `https://i.pravatar.cc/150?u=a04258114e${me?.username}`
  const imageSrc = me?.avatar_url || defaultAvatar


  const handleLogOutClick = async (e) => {
    e.preventDefault()
    await logout()
    toast.success(translateIt(countryId, "logout_success"))
  }

  return (
    <Dropdown>
      <DropdownTrigger>
        <Avatar src={imageSrc} size={size} slots={{ img: { disableAnimation: true } }} />
      </DropdownTrigger>
      <DropdownMenu disabledKeys={["username",]} aria-label="Drop down menu">
        <DropdownItem key="username" aria-label='Username'>
          {me.username}
        </DropdownItem>
        <DropdownItem key="following" aria-label='Following'>
          <Link href={Route.MeFollowing()} className='block'>
            Following
          </Link>
        </DropdownItem>
        {me.is_staff && (
          <DropdownItem>
            <Link href={EditorRoute.Home()} className='block'>
              Editor
            </Link>
          </DropdownItem>

        )}
        <DropdownItem key="Logout" aria-label='Logout'>
          <div onClick={handleLogOutClick} className="block">
            {translateIt(countryId, "logout")}
          </div>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
